import axios from 'axios';
import { useApiConfigStore } from '@store/api_config';

const publicClient = axios.create();

publicClient.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export interface SigningPageData {
  doc_title: string;
  project_name: string;
  conductor_name: string;
  signer_name: string;
  pdf_url: string;
  status: 'pending' | 'signed' | 'expired' | 'superseded';
}

export interface SigningResult {
  success: boolean;
  message: string;
}

export const getSigningData = (token: string): Promise<SigningPageData> =>
  publicClient.get(`/generated-documents/sign/${token}`).then((r) => r.data);

export const submitSignature = (token: string, signatureFile: File): Promise<SigningResult> => {
  const formData = new FormData();
  formData.append('signature', signatureFile);
  return publicClient.post(`/generated-documents/sign/${token}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};
